jQuery('.form .collapse').each(function (index, element) {
  let $collapse = jQuery(element)
  if ($collapse.find('input[type="checkbox"]:checked').length > 0) {
    $collapse.collapse('show')
  } else {
    if ($collapse.find('textarea').filter(function (index, element) {
      return jQuery(element).val().length > 0
    }).length > 0) {
      $collapse.collapse('show')
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/forms/scripts.js